import { ActivityTagCell } from "PFApp/components/activity_tag_cell";
import { RoleAvailability } from "PFComponents/availability";
import { RoleStatusBadge } from "PFComponents/role/role_status_badge";
import { RoleVacanciesBadge } from "PFComponents/role/role_vacancies_badge";
import { daysFromNowFormat } from "PFCore/helpers/date";

export const getRolesCellRenderers = () => ({
  engagement: ({ getValue }) => getValue()?.name,
  availability: ({ row }) => <RoleAvailability role={row.original.activity} />,
  vacancies: ({ row }) => <RoleVacanciesBadge role={row.original.activity} />,
  workflow_state: ({ getValue }) => <RoleStatusBadge workflowState={getValue()} />,
  due: ({ row }) => {
    const item = row.original.activity;
    return item.state === "complete" ? "-" : daysFromNowFormat(item.post_until);
  },
  activity_tag: ({ getValue }) => <ActivityTagCell value={getValue()} />
});
